module.exports = __webpack_public_path__ + "static/media/Grid.1caf8962.svg";